define('BookingEngine/app-Departures/main',['./settings', "util", '../app-BookNow/main', '../app-BEBasket/module', '../app-FlightUpgrades/main', '../app-General/dialog', "../../app-Loader/main", "moment"],
    function (settings, util, booknow, beBasket, flightUpgrades, generalDialog, loader, moment) {
        return {
               //ActivateDepartures function: This function is called when the filters are changed at the top of the page. 
               //It reloads the departures with the new information from the activatemodule call.

               //ACTIVATE THE DEPARTURES MODULE AFTER FILTER SELECT.
            ActivateDepartures: function () {
                console.log('app-departures ActivateDepartures');
                   $.ajax({
                       url: "/departuresmodule/activatemodule",
                       type: "GET",
                       success: function (departureResult) {
                           console.log('app-departures ActivateDepartures complete');
                           $("#loadDepartures").empty().html(departureResult).show();

                           //On page reload if a filter is selected, make date active and hide all pods apart from date, week, month.
                           $('#Transport.departurePod').addClass("d-block d-md-flex");
                           $('.orderTransport').addClass('active');

                           //Convert port description with the dictionary, eg: LGW becomes London Gatwick Airport.
                           $.each($('.depSelectedDepPoint'), function () {
                               var dpval = $(this).text().trim();
                               $(this).find('.sortval').html(PortDescriptionDictionary[dpval]);
                           });

                           //Convert the board basis using the dictionary, eg: HB becomes Half board.
                           $.each($('.depSelectedBoard'), function () {
                               var depval = this.dataset.boardbasis;
                               $(this).find('.sortval').html(BbDescriptionDictionary[depval]);
                           });
                       },
                       error: function () {
                           console.log("There was an error with the departures module.");
                       }
                   });              
               },
               run: function () {
                   var summary = $(settings.container); 

                   if (summary.length === 0) {
                       window.log("The departures module is not available.");
                       return;
                   }

                   window.log("Loading departure Module");

                   function isNullUndefEmpty(variable) {
                       return (variable === null || variable === undefined || variable === '');
                   }

                   var departuresModule = $("#depModuleActive"),
                       numDeparturePods = departuresModule.find(".departurePod").length,
                       numDepartures = departuresModule.find(".departuresTable").length;

                   if (numDeparturePods >= 1 || numDepartures >= 1) {
                       loader.hide();
                   }

                   //Load departures table data only when a pod is clicked on, not on page load.
                   $(document).on("click", ".departurePod", function () {
                       var podselectedText = $(this).find('.departuresAvailable').text().trim();
                       podselectedText = podselectedText.replace(/[\n\r]/g, '');
                       AdlAddUpdateItem("departureAggregatedList", podselectedText);

                       var departurePodKey = $(this).data('dt'),
                           departurePodType = $(this).attr('id'),
                           departurePod = this;

                       //Get the podkey and pod type and send this back to the model.
                       var getPodKey = {
                           "podKey": departurePodKey,
                           "podType": departurePodType
                       }

                       //If the departures table has departures in it (has been loaded before).
                       if ($(departurePod).next('.departurePodInfo').find('.departuresTable').length > 1) {
                           loader.hide();
                       } else {
                           //Else make an ajax call to go and get the departures for this pod. 
                           //Send the getPodKey info back to the model.
                           //ACTIVATE THE DEPARTURES MODULE.
                           $.ajax({
                               url: "/departurestable/departurestable",
                               dataType: "html",
                               data: JSON.stringify(getPodKey),
                               type: "POST",
                               contentType: "application/json; charset=utf-8",
                               success: function(data) {
                                   //The data that we are sent back place into the getDeparturesTable.
                                   $(departurePod).next(".departurePodInfo").find(".getDeparturesTable").html(data);

                                   //Convert port description with the dictionary, eg: LGW becomes London Gatwick Airport.
                                   $.each($(".depSelectedDepPoint"),
                                       function() {
                                           var dpval = $(this).text().trim();
                                           $(this).find(".sortval").html(PortDescriptionDictionary[dpval]);
                                       });

                                   //Convert the board basis using the dictionary, eg: HB becomes Half board.
                                   $.each($(".depSelectedBoard"),
                                       function() {
                                           var depval = this.dataset.boardbasis;
                                           $(this).find(".sortval").html(BbDescriptionDictionary[depval]);
                                       });

                                   //Show 10 departures default.
                                   $(departurePod).next(".departurePodInfo").find('.departuresTable').slice(0, 10).show();

                                   var departureResults = $(departurePod).next(".departurePodInfo").find(".departuresTable").length,
                                       resultsShown = $(departurePod).next(".departurePodInfo").find(".departuresTable:visible").length;

                                   //If each departure pod contains more than 10 departure tables, add a show more button.
                                   if (departureResults < 10) {
                                       $(".showTenResults").hide();
                                   } else {
                                       $(".showTenResults").show();

                                       if (resultsShown === departureResults) {
                                           $(".showTenResults").hide();
                                       }
                                   }

                                   //Remove sort icon from rows that have the same value.
                                   discoverSortable();

                                   loader.hide();
                               },
                               error: function(error) {
                                   console.log("There was an error: " + error);
                                   loader.hide();
                               }
                           });
                       }
                   });

                   function adlPageDeps() {
                       util.satelliteTrack("virtualPageViewTBJ");

                       //after the tracking call set previous page name to this value
                       //set a timeout to prevent it getting set before it's been read
                       //also add it to local storage so that a page change picks up the correct value
                       setTimeout(function () {
                           //localStorage.setItem("previousPageName", "travel|purchase|checkout|departures");
                           //AdlAddUpdateItem("previousPageName", "travel|purchase|checkout|departures");
                           var prevpage = localStorage.getItem("previousPageName");
                           if (!isNullUndefEmpty(prevpage)) {
                               AdlAddUpdateItem("previousPageName", prevpage);
                           }
                           localStorage.setItem("previousPageName", "travel|purchase|checkout|departures");
                       }, 999);
                   };

                   clearTimeout(VPVtimer);
                   VPVtimer = setTimeout(adlPageDeps, 250);

                   //Hash back/forward button change values. 
                   //When the back or forward buttons are clicked it will stop at these anchor points. 
                   function locationofHashChanged() {
                       window.location.hash.replace('#', '');

                       //Departure summary anchor...
                       if (window.location.hash === "#ds") {
                           $('html, body').animate({
                               scrollTop: $("#depModuleSummary").offset().top
                           });
                       }
                           //Transport summary anchor...
                       else if (window.location.hash === "#ts") {
                           $('html, body').animate({
                               scrollTop: $("#transportModuleSummary").offset().top
                           });
                       }
                           //Room summary anchor...
                       else if (window.location.hash === "#rs") {
                           $('html, body').animate({
                               scrollTop: $("#roomModuleSummary").offset().top
                           });
                       }
                           //Else if the hash is empty...
                       else if (window.location.hash === "") {
                           $('html, body').animate({ scrollTop: 0 }, "slow");
                       }
                   }

                   //Update the hash value.
                   window.onhashchange = locationofHashChanged;

                   // Update Progress bar
                   $('#yourHoliday').addClass('current');

                   function getParameterByName(name, url) {
                       if (!url) url = window.location.href;

                       name = name.replace(/[\[\]]/g, "\\$&");

                       var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                           results = regex.exec(url);

                       if (!results) return null;
                       if (!results[2]) return '';

                       return decodeURIComponent(results[2].replace(/\+/g, " "));
                   }

                   var productid = getParameterByName('productid');

                   var request = $.ajax({
                       url: '/basketitinerary/getsitecoreitinerary?productid=' + productid,
                       cache: false,
                       async: true,
                       dataType: "json"
                   });

                   request.done(function (result) {
                       var itineraries = result.data.length;

                       if (!result.multiitinhide) {
                           for (var i = 0; i < itineraries; i++) {
                               $('#btnContainer').append('<div class="btn-group"><input type="button" class="btn btn-third btnItinerary" data-itinid= "' + result.data[i].id + '"  value=" View Itinerary ' + result.data[i].description + '"/></div>');
                           }
                           itineraries <= 1 ? $('.btnItineraryHolder').remove() : $('.btnItineraryHolder').hide();
                       } else {
                           $('.btnItineraryHolder').show();
                       };

                       //Hiding itinerary button which displays taurus and sitecore itinerary
                       $('#btnContainer, #booknow').on('click', '.btnItinerary', function () {
                           //ADL call
                           AdlAddUpdateItem("pageName", "travel|purchase|checkout|viewitinerary");

                           function adlViewItin() {
                               util.satelliteTrack("virtualPageViewTBJ");

                               //after the tracking call set previous page name to this value
                               //set a timeout to prevent it getting set before it's been read
                               //also add it to local storage so that a page change picks up the correct value
                               setTimeout(function () {
                                   var prevpage = localStorage.getItem("previousPageName");

                                   if (!isNullUndefEmpty(prevpage)) {
                                       AdlAddUpdateItem("previousPageName", prevpage);
                                   }

                                   localStorage.setItem("previousPageName", "travel|purchase|checkout|viewitinerary");
                               }, 999);
                           };

                           clearTimeout(VPVtimer);
                           VPVtimer = setTimeout(adlViewItin, 250);

                           var itinid = $(this).data("itinid"),
                               itinurl = itinid
                               ? "/basketitinerary/getitinerarybyid?id=" + itinid
                               : "/basketitinerary/index";

                           generalDialog.showDialog(itinurl);
                       });
                   });

                   //Update the basket: This is because if we refresh the page the basket wont show empty.
                   beBasket.updateBasket();

                   //If the pod description contains airport, then add a plane icon to it.
                   $('.doPodDesc').each(function () {
                       if ($(this).text().indexOf('Airport') != -1) {
                           $(this).closest('.bookingDropdown').find('.checkoutIcon').addClass('fa fa-plane');
                       }
                   });

                   //Global DOM event Handlers!!
                   // Change transport button when using .on this attaches an event whether the specified id exists or not in the DOM 
                   // (i.e. events bubble up to this event handler at the top level if an event handler isn't specifically attached to the id directly)
                   $(document).on('click', '.changeFlights', function () {
                       if ($('#transportModuleActive').length === 0) {
                           getTransportActive();
                       }

                       showActiveTransport();
                       CloseAllOthers("changeFlights");
                   });

                   //Hide/show for each of the departure pods.  
                   $(document).on('click', '.departurePod', function (e) {
                       e.preventDefault();

                       loader.show();

                       //For default: Remove the selected class on click and change the chevron to point down.
                       $('.departurePod', '.departurePodInfo').removeClass('active');
                       var showHideDiv = $(this).next('.departurePodInfo');
                       //Hide all div's that aren't the current one that has been clicked.
                       $('.departurePodInfo').not(showHideDiv).slideUp('slow');
                       //Hide the div, remove selected class and add chevron down.
                       if (showHideDiv.is(":visible")) {
                           showHideDiv.slideUp('slow');
                           $(this).removeClass('active');
                           $(showHideDiv).removeClass('active');
                       } else {
                           //Show the div, add selected and add chevron up.
                           $(this).addClass('active');
                           $(showHideDiv).addClass('active');
                           $(showHideDiv).slideDown("slow", function () {
                               $("html, body").animate({ scrollTop: $(this).prev('.departurePod').offset().top }, 'slow', 'swing');
                           });
                       }

                       //Show 10 departures default.
                       $(this).next('.departurePodInfo').find('.departuresTable').slice(0, 10).show();
                       var departureResults = $(this).next('.departurePodInfo').find('.departuresTable').length,
                           resultsShown = $(this).next('.departurePodInfo').find('.departuresTable:visible').length;

                       //If each departure pod contains more than 10 departure tables, add a show more button.
                       if (departureResults < 10) {
                           $('.showTenResults').hide();
                       } else {
                           resultsShown === departureResults ? $('.showTenResults').hide() : $('.showTenResults').show();
                       }

                       loader.hide();
                   });

                   //Show 10 departures default; On click of the show more button show more.
                   $(document).on('click', '.showTenResults', function () {
                       var departurePod = $(this).closest('.departurePodInfo'),
                           departureResults = departurePod.find('.departuresTable').length,
                           resultsToShow = departurePod.find('.departuresTable:visible').length + 10;

                       if (resultsToShow < departureResults) {
                           departurePod.find('.departuresTable').slice(0, resultsToShow).css('display', 'flex');
                       } else {
                           departurePod.find('.departuresTable').slice(0, departureResults).show();
                           $('.showTenResults').hide();
                       }
                   });

                   //To handle if the departures have no pods. Do not display the show more button and add table-row to each departures table.
                   if ($('.departurePodInfo').find('.departuresTable').length < 10) {
                       $('.showTenResults').hide();
                   }

                   //Moment: Format the date eg, 20161208 > this is what will be used for sorting and sending back to the database.
                   var g = $('.depSelectedDate').data('departuredate');
                   moment(g).format("YYYYMMDD");

                   if ($('.departureFiltersButtons .btn-group ').find(".orderTransport").length === 0) {
                       $('.departurePod:not(#Month)').hide();
                       $('.orderDate ').addClass('active');
                   } else {
                       $('.departurePod:not(#Transport)').hide();
                       $('.orderTransport ').addClass('active');
                   }

                   //Order airports button.                                                       
                   $(document).on('click', '.orderTransport', function () {
                       // adobe
                       var departurepods = $('#totalAirportPods').text();
                       AdlAddUpdateItem("numberOfDepartureLists", departurepods);
                       AdlAddUpdateItem("departureViewOption", "AIRPORT");

                       //On click of the filter buttons, hide any pod info boxes that might have been open.
                       $(".departurePodInfo").hide();
                       $('.departurePod').removeClass("d-block d-md-flex active");
                       $('#Transport.departurePod').addClass("d-block d-md-flex");

                       //Then finally remove the other classes that are not relevant to this button.
                       $('a').removeClass('selected');
                       $(this).addClass('active').siblings().removeClass('active');
                   });

                   //Order date button.
                   $(document).on('click', '.orderDate', function () {
                       // adobe
                       var departurepods = $('#totalDatePods').text();
                       AdlAddUpdateItem("numberOfDepartureLists", departurepods);
                       AdlAddUpdateItem("departureViewOption", "DATE");

                       //On click of the filter buttons, hide any pod info boxes that might have been open.
                       $(".departurePodInfo").hide();
                       $('.departurePod').removeClass("d-block d-md-flex active");

                       if ($('#Month.departurePod').length) {
                           $('#Month.departurePod').addClass("d-block d-md-flex");
                       } else {
                           $('#Week.departurePod').addClass("d-block d-md-flex");
                       }

                       //Then finally remove the other classes that are not relevant to this button.
                       $('a').removeClass('selected');
                       $(this).addClass('active').siblings().removeClass('active');
                   });

                   //Order nights button.
                   $(document).on('click', '.orderNights', function () {
                       // adobe
                       var departurepods = $('#totalNightsPods').text();
                       AdlAddUpdateItem("numberOfDepartureLists", departurepods);
                       AdlAddUpdateItem("departureViewOption", "NIGHTS");

                       //On click of the filter buttons, hide any pod info boxes that might have been open.
                       $(".departurePodInfo").hide();
                       $('.departurePod').removeClass("d-block d-md-flex active");
                       $('#Duration.departurePod').addClass("d-block d-md-flex");

                       //Then finally remove the other classes that are not relevant to this button.
                       $('a').removeClass('selected');
                       $(this).addClass('active').siblings().removeClass('active');
                   });

                   //Table sort: Sorting the data in the departures table.
                   $(document).on('click', '.head div', function () {
                       var table = $(this).parents('.bookingTableFlex').eq(0),
                           columnIndex = $(this).index(),
                           sortable = isColumnSortable(table, columnIndex);

                       //Only sort if we have something to sort.
                       if (sortable) {
                           var rows = table.find(".departuresTable").toArray().sort(sortColumn($(this).index()));
                           //To reset the icon to double when a new 'th' is clicked.
                           $('.sortT i').addClass('fa-sort').removeClass('fa-sort-up').removeClass('fa-sort-down');

                           //As price/departure date/cabin number are ascending by default for travel/cruises/cabin selection respectively (yes, cabins use this script too....)
                           //Initial order must be descending if not already set
                           this.asc = this.asc === undefined && ($(this).hasClass("priceCol") || $(this).hasClass("departureCol") || $(this).hasClass("cabindetail")) 
                               ? false : !this.asc;  
             
                           if (!this.asc) {
                               rows = rows.reverse();
                               //Add the descending sort icon.
                               $(this).find('.sortT i').addClass('fa-sort-down').removeClass('fa-sort-up').removeClass('fa-sort');
                               AdlAddUpdateItem("departureSortOrder", $(this).text() + " - DESCENDING");
                           } else {
                               //Add the sort ascending sort icon.
                               $(this).find('.sortT i').addClass('fa-sort-up').removeClass('fa-sort-down').removeClass('fa-sort');
                               AdlAddUpdateItem("departureSortOrder", $(this).text() + " - ASCENDING");
                           }

                           for (var i = 0; i < rows.length; i++) {
                               //Append the rows to the table.
                               table.append(rows[i]);
                           }
                       }
                   });

                   //Sort the columns, whether numeric or string.
                   function sortColumn(index) {
                       return function (a, b) {
                           var sortA = $(a).children().eq(index).find("*[data-sort-val]").data("sort-val"),
                               sortB = $(b).children().eq(index).find("*[data-sort-val]").data("sort-val");
                           return $.isNumeric(sortA) && $.isNumeric(sortB) ? sortA - sortB : sortA.localeCompare(sortB);
                       }
                   }

                   function getColumnValues(table, index) {
                       var values = [];

                       $(table).find('.departuresTable').each(function() {
                           var sortingValue = $(this).find("div").eq(index).find("*[data-sort-val]").data("sort-val");

                           if (sortingValue) {
                               values.push(sortingValue);
                           }
                       });

                       return values;
                   }

                   //Function to work out if the column contains values that are the same.
                   function isColumnSortable(table, index) {
                       var arr = getColumnValues(table, index),
                           allRowsTheSame = true; // default is 'sortable=true'

                       if (arr.length > 0) {
                           allRowsTheSame = !!arr.reduce(function (a, b) { return (a === b) ? a : NaN; });
                       }

                       return !allRowsTheSame;
                   }

                   //If the column is not sortable remove the sort icon, else add the sort icon.
                   function discoverSortable() {
                       $('.bookingTableFlex .head div').each(function () {
                           var columnindex = $(this).index(),
                               table = $(this).closest('.bookingTableFlex');

                           !isColumnSortable(table, columnindex)
                               ? $(this).find('.sortT').addClass("hidden")
                               : $(this).find('.sortT').removeClass("hidden");
                       });
                   }

                   //Hide the sort icons on any columns where the values are the same in every row on page load.
                   $(document).ready(function () {
                       discoverSortable();
                   });

                   if (!$("#editFiltersContainer").is(":visible")) {
                       $("#depModuleDisabled").hide();
                   }

                   //Change departure button.
                   $(document).on("click", ".changeDeparture", function () {
                       showActiveDepartures();
                       CloseAllOthers("changeDeparture");
                   });

                   //Select departure button.
                   $(document).on("click", ".selectDeparture", function (selectedDeparture) {
                       AdlAddUpdateItem("BookingJourneyStep", "departuredate");

                       var $this = $(this),
                       departuresTable = $this.closest(".departuresTable"),
                       getBtnId = $this.attr("id"),
                       getTableId = departuresTable.attr("id");                       

                       //Highlight only the departure that is selected.
                       $(".departuresTable").removeClass("tableSelected");
                       departuresTable.addClass("tableSelected");
                       
                       $(".selectDeparture").removeClass("btn-success").text("Select");
                       $this.addClass('btn-success').text("Selected");
                       
                       //If these ids match then get the text values from each column in that row.
                       if (selectedDeparture.target.id === getTableId) {
                           loader.show("Saving your departure choice...");

                           var s1 = departuresTable.find(".depSelectedDate").find(".sortval").text().trim(),
                               s9 = departuresTable.find(".depSelectedDate").data("departuredate"),
                               s2 = departuresTable.find(".depSelectedRoom").text().trim(),
                               s3 = departuresTable.find(".depSelectedBoard").data("boardbasis"),
                               s5 = departuresTable.find(".depSelectedDuration").find(".sortval").text().trim(),
                               s6 = $this.data("deppoint").toString(),
                               s7 = $this.data("itincode"),
                               s8 = BbDescriptionDictionary[s3] === undefined ? s3 : BbDescriptionDictionary[s3],
                               s10 = $this.data("source"),
                               s11 = $this.data("carrier"),
                               travelStartDate = departuresTable.find(".depSelectedDate").data("adl-travel-start-date"),
                               travelEndDate = departuresTable.find(".depSelectedDate").data("adl-travel-end-date");

                           var departureMoreSeats = $this.data("more-seats").toLowerCase() === "true";

                           //Make the select call to store these values into the database.
                           //Assign the text values above to each variable in the model.
                           //Push to the database via the call.
                           //Get flag to say whether that was a success and then make the next module active.
                           //If flag was successful then set this module to summary and set next module to active (transport).

                           //Get the values to populate the summary.
                           var convertDepartFrom = $("#" + getBtnId + ".departuresTable .selectDeparture").data("deppoint");

                           $(".depSelDepPoint").html("<strong>Departing from:</strong> " + PortDescriptionDictionary[convertDepartFrom]);
                           $(".depSelDepDate").html("<strong>Leaving:</strong> " + s1).text().trim();
                           $(".depSelDepDuration").html("<strong>Staying for:</strong> " + s5 + " nights");
                           $(".depSelDepBoardBasis").html("<strong>Board Basis:</strong> " + s8);

                           //Departure values to send back to the database.
                           var departuresModel = {
                               "BoardBasis": s3,
                               "DeparturePoint": s6,
                               "DepartureDate": s9,
                               "ItineraryCode": s7,
                               "Duration": s5,
                               "DataSource": s10
                           }

                           // adobe
                           localStorage.setItem("boardBasis", s8.toString());
                           AdlAddUpdateItem("boardBasis", s8.toString());

                           var depPoint = (PortDescriptionDictionary[convertDepartFrom] === undefined) ? convertDepartFrom : PortDescriptionDictionary[convertDepartFrom];

                           localStorage.setItem("departurePoint", depPoint);
                           AdlAddUpdateItem("departurePoint", depPoint);
                           var formattedDepDate = $.datepicker.formatDate("dd/mm/y", new Date(s1));
                           localStorage.setItem("departureDate", formattedDepDate);
                           AdlAddUpdateItem("departureDate", formattedDepDate);

                           localStorage.setItem("numberOfNights", s5.toString());
                           AdlAddUpdateItem("numberOfNights", s5.toString());

                           localStorage.setItem("occupancy", s2.toString());
                           AdlAddUpdateItem("occupancy", s2.toString());

                           localStorage.setItem("metaTravelStartDate", travelStartDate);
                           AdlAddUpdateItem("metaTravelStartDate", travelStartDate);

                           localStorage.setItem("metaTravelEndDate", travelEndDate);
                           AdlAddUpdateItem("metaTravelEndDate", travelEndDate);

                           //POST SELECTED DEPARTURES > GET FLAG.
                           $.ajax({
                               url: "/departuresmodule/select",
                               type: "POST",
                               data: JSON.stringify(departuresModel),
                               dataType: "json",
                               contentType: "application/json; charset=utf-8",
                               success: function (departureData) {
                                   if (departureData.success) {
                                       $("#depModuleSummary").attr("data-summary", "summary");
                                       $("#transportModuleSummary", "#roomModuleSummary").attr("data-summary", "noSummary");

                                       booknow.UpdateSummary("noSummary");

                                       //If we select a new departure, close cabin summary if active.
                                       if ($("#othercruisePickYourCabin").is(":visible")) {
                                           closeCabins();
                                       }

                                       $("#depModuleActive, .filtersActive, #depModuleDisabled").hide();
                                       $("#depModuleSummary, .filtersSummary").show();
                                       $("html, body").animate({ scrollTop: $("#depModuleSummary").offset().top + $('#depModuleSummary')[0].scrollHeight + 5 }, "fast", "swing");                                       

                                       //Update the basket.
                                       beBasket.updateBasket();

                                       //Hiding multiple sitecore itinerary buttons.
                                       var buttons = $("#btnContainer > .btn-group > .btnItinerary");

                                       if (buttons.length > 1) {
                                           buttons.hide();
                                       }

                                       //Ajax call to check if this itinerary has any days. 
                                       var showhideitin = $.ajax({
                                           url: "/basketitinerary/ShowItinerary",
                                           cache: false,
                                           async: true,
                                           dataType: "json"
                                       });

                                       //If there are days then show the itinerary button.
                                       showhideitin.done(function (result) {
                                           if (result) {
                                               $(".btnItineraryHolder").show();
                                           } 
                                       });

                                       //If departure port (data-deppoint) is not NONE and if the first 2 letters of the holiday code are not XX,
                                       //close all others and activate transport.
                                       if (s6 !== "NONE" && s6.substring(0, 2) !== "XX" && s11.toLowerCase() !== "false") {
                                           $("#roomModuleSummary").hide().attr("data-summary", "noSummary");
                                           CloseAllOthers("changeFlights");
                                           getTransportActive(departureMoreSeats);
                                       } else {
                                           $("#transportModuleDisabled").hide();
                                           $("#transportModuleSummary").hide().attr("data-summary", "noSummary");

                                           var cabinsActive = $("#othercruisePickYourCabin").is(":visible");

                                           //River & Third Party Cruises - get cabins
                                           if (cabinsActive) {
                                               getCabinActive();
                                           } else {
                                               CloseAllOthers("changeRooms");
                                               getRoomsActive();
                                               showActiveRooms();
                                           }
                                       }
                                   }
                               },
                               error: function () {
                                   loader.hide();
                                   console.error("There was an error:" + data.errorDetails);
                               }
                           });
                       }
                   });

                   //On click of the change departures button, make departures active and close all others to the disabled state UNLESS they have been set to summary,
                   //otherwise show these in summary.
                   $(document).on('click', '.changeDeparture', function () {
                       showActiveDepartures();
                       CloseAllOthers("changeDeparture");
                   });

                   //On click of the change rooms button, make rooms active and close all others to the disabled state UNLESS they have been set to summary,
                   //otherwise show these in summary.
                   $(document).on('click', '.changeRooms', function () {
                       showActiveRooms();
                       CloseAllOthers("changeRooms");
                       getRoomsActive();
                   });

                   //Toggle the text for room features.
                   $('body').on('click', 'a.viewAllRoom', function (e) {
                       e.preventDefault();
                       $(this).next('.roFeatures, .selroFeatures').slideToggle("slow");
                       $(this).text($(this).text() == 'View all room features' ? 'Hide all room features' : 'View all room features');
                   });

                   //On click of selecting flight/transport. 
                   $(document).on('click', '.selectFlights', function (flight) {
                       //Highlight only the transport that is selected.
                       $('.flights').removeClass('flightSelected');
                       //Make sure that if any flight upgrades were selected they go back to a primary button also.
                       $('.selectFlightUpgrade').removeClass('btn-success').text("select");
                       $(this).addClass('btn-success');

                       $(this).closest('.flights').addClass('flightSelected');
                       //If transport option contains the word airport, change button txt to select flight/selected flight when selected.
                       if ($('.toOutboundPort').text().toLowerCase().indexOf("airport") >= 0) {
                           $(this).text("Selected flight");
                           $(this).find('.bookFlightUpgrades .upgradesTable .upgradeFlightButton').removeClass('btn-success').text("Select");
                       }
                        //If transport option contains the word Eurostar, change button txt to select this Eurostar/selected Eurostar when selected.
                       else if ($('.toCarrierName').text().toLowerCase().indexOf("eurostar") >= 0) {
                           $(this).text("Selected Eurostar");
                       }
                        //Else just display the button text selected.
                       else {
                           $(this).text("Selected");
                       }

                       //Get the parent of the btn (departuresTable) id.                                                          
                       var getFlightTableId = $(this).closest('.flights').attr('id');

                       //If these ids match then get the text values from the table.
                       if (flight.target.id === getFlightTableId) {
                           //Adobe
                           AdlAddUpdateItem("BookingJourneyStep", "transport");

                           loader.show("Saving your transport choice...");

                           selectedFlightInfoAndSummary($(this));
                       }

                       // adobe
                       var transportType = $(this).closest('.flights').find('#Outbound .flightsBodyDeparture .toOutboundPort').text();
                       AdlAddUpdateItem("transportType", transportType);
                       localStorage.setItem("transportType", transportType);
                   });

                   //Load the flight upgrades on click of the upgrade flights button.
                   $(document).on('click', '.upgradeFlight', function (upgrade) {
                       var getFlightTableId = $(this).closest('.flights').attr('id');
                       //If these ids match then get the text values from the table.
                       if (upgrade.target.id === getFlightTableId) {

                           //To stop the button doing an ajax call if it's already been pressed and the information is already there.
                           if ($(this).closest('.flights').find('.bookFlightUpgrades').find('.flightUpgradesContainer').length) {
                               $(this).closest('.flights').find('.bookFlightUpgrades').show();
                               $(this).closest('.flightsBodyButton').find('.cancelFlightUpgrades').show();
                               $(this).closest('.flightsBodyButton').find('.upgradeFlight').hide();
                           } else {
                               //If the button hasn't been pressed then go do the ajax request to get us the information needed.
                               //Show the upgrades loading twirler.
                               $(this).closest('.flightsBodyButton').find('.upgradescheck').show();

                               var getFlightNo = $(this).closest('.flightsBodyButton').find('.selectFlights').attr('id');
                               var getIsFlightAlternative = $(this).closest('.flightsBodyButton').find('.selectFlights').data('flightalt');

                               //Combined from all outbound legs (e.g. UU).
                               var allOutboundBookingClasses = $.map($(this).closest('.flights').find('.Outbound'), function (joinOut) {
                                   return $(joinOut).data('bc');
                               }).join("");

                               //From first out bound leg (e.g. ECONOMY).
                               var getOutboundCabinClass = $(this).closest('.flights').find('.Outbound').data('cc');

                               //Combined from all inbound legs (e.g. UU).
                               var allInboundBookingClasses = $.map($(this).closest('.flights').find('.Inbound'), function (joinIn) {
                                   return $(joinIn).data('bc');
                               }).join("");

                               //From first out bound leg (e.g. ECONOMY).
                               var getInboundCabinClass = $(this).closest('.flights').find('.Inbound').data('cc');

                               var flightUpgradeId = this;

                               //Get the flight upgrade info and send this back to the model.
                               var getFlightUpgradeInfo = {
                                   "flightNo": getFlightNo,
                                   "isFlightAlternative": getIsFlightAlternative,
                                   "inboundBookingClass": allInboundBookingClasses,
                                   "inboundCabinClass": getInboundCabinClass,
                                   "outboundBookingClass": allOutboundBookingClasses,
                                   "outboundCabinClass": getOutboundCabinClass,
                               }

                               //ACTIVATE FLIGHT UPGRADES.
                               $.ajax(
                               {
                                   url: '/transportmodule/activateflightupgrade',
                                   dataType: 'html',
                                   data: JSON.stringify(getFlightUpgradeInfo),
                                   type: 'POST',
                                   contentType: 'application/json; charset=utf-8',
                                   success: function (flightUpgrade) {
                                       if (flightUpgrade.trim() != "") {
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.upgradescheck').hide();
                                           $(flightUpgradeId).closest('.flights').find('.bookFlightUpgrades').empty();
                                           $(flightUpgradeId).closest('.flights').find('.bookFlightUpgrades').html(flightUpgrade).show();
                                           //$(flightUpgradeId).closest('.bookFlightUpgrades').find('.selectFlightUpgrade').attr("id", getFlightNo);
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.cancelFlightUpgrades').show();
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.upgradeFlight').hide();

                                           $('html, body').animate({
                                               scrollTop: $(".flightUpgradesContainer").offset().top
                                           });
                                           //If when the flight upgrades call completes and tells us that flight upgrades are available.
                                           //Do this second check to check that this package actually contains upgrades inside it.
                                           //This fix was put in for when holidays aren't set up correctly and so are returning as available 
                                           //but have no upgrades, which caused the flight upgrades headings to display with no results below.
                                           if ($('.upgradesTable').find('.flightUpgradesBody').children().length > 0) {
                                               flightUpgrades.ActivateFlightUpgrades();
                                           } else {
                                               $(flightUpgradeId).closest('.flightsBodyButton').find('.toTransfersIncluded').hide();
                                               $(flightUpgradeId).closest('.flightsBodyButton').find('.toFlightUpgrades').hide();
                                               $(flightUpgradeId).closest('.flightsBodyButton').next('.bookFlightUpgrades').hide();
                                               $(flightUpgradeId).closest('.flightsBodyButton').find('.upgradesError').show();
                                           }
                                       } else {
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.toTransfersIncluded').hide();
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.toFlightUpgrades').hide();
                                           $(flightUpgradeId).closest('.flightsBodyButton').next('.bookFlightUpgrades').hide();
                                           $(flightUpgradeId).closest('.flightsBodyButton').find('.upgradesError').show();
                                       }

                                   },
                                   error: function () {
                                       $(flightUpgradeId).closest('.flightsBodyButton').find('.toTransfersIncluded').hide();
                                       $(flightUpgradeId).closest('.flightsBodyButton').find('.toFlightUpgrades').hide();
                                       $(flightUpgradeId).closest('.flightsBodyButton').find('.upgradesError').show();
                                   }
                               });
                           }
                       }
                   });

                   //Select call for the flight upgrades.
                   $(document).on('click', '.selectFlightUpgrade', function () {
                       selectedFlightInfoAndSummary($(this));
                       //Make sure that if any flight upgrades were previously selected go back to a primary button state.
                       $('.selectFlightUpgrade').removeClass('btn-success').addClass('btn-primary').text("Select");
                       $('.selectFlights').removeClass('btn-success').addClass('btn-primary').text("select flight");
                       $(this).removeClass('btn-primary').addClass('btn-success').text("Selected");
                   });

                   //Select to post the info to be stored in the database, and to get the summary info to display.
                   function selectedFlightInfoAndSummary(passFlightNo) {
                       //Pass the flight number to be stored to the database.
                       var flightno = passFlightNo.attr('id');

                       //UU - combined from all outbound legs
                       var allOutboundBookingClasses = $.map(passFlightNo.closest('.flightUpgradesSection').find('.outupCarrierName'), function (joinOutBc) {
                           return $(joinOutBc).data('upoutbookclass');
                       }).join("");

                       //ECONOMY - from first out bound leg
                       var getOutboundCabinClasses = $.map(passFlightNo.closest('.flightUpgradesSection').find('.outupCarrierName'), function (joinOutCc) {
                           return $(joinOutCc).data('upoutcabinclass');
                       }).join(",");

                       //UU - combined from all outbound legs
                       var allInboundBookingClasses = $.map(passFlightNo.closest('.flightUpgradesSection').find('.inupCarrierName'), function (joinInBc) {
                           return $(joinInBc).data('upinbookclass');
                       }).join("");

                       //ECONOMY - from first out bound leg
                       var getInboundCabinClasses = $.map(passFlightNo.closest('.flightUpgradesSection').find('.inupCarrierName'), function (joinInCc) {
                           return $(joinInCc).data('upincabinclass');
                       }).join(",");

                       //Get the flight upgrade info and send this back to the model.
                       var getFlightUpgradeInfo = {
                           "departureOptionidentifier": flightno,
                           "upgradesInboundBookingClass": allInboundBookingClasses,
                           "upgradesInboundCabinClass": getInboundCabinClasses,
                           "upgradesOutboundBookingClass": allOutboundBookingClasses,
                           "upgradesOutboundCabinClass": getOutboundCabinClasses,
                       }

                       var moreSeatsId = passFlightNo.data("more-seats-id");

                       if (moreSeatsId) {
                           getFlightUpgradeInfo["moreSeatsId"] = moreSeatsId;
                       }

                       //POST SELECTED TRANSPORT > GET FLAG.
                       $.ajax({
                           url: '/transportmodule/selectflightupgrade',
                           type: 'POST',
                           data: JSON.stringify(getFlightUpgradeInfo),
                           dataType: 'json',
                           contentType: 'application/json; charset=utf-8',
                           success: function (transportData) {
                               if (transportData.success) {
                                   $('#transportModuleSummary').attr('data-summary', 'summary');
                                   $('#roomModuleSummary').attr('data-summary', 'noSummary');
                                   booknow.UpdateSummary("noSummary");
                                   CloseAllOthers("changeRooms");

                                   //Rooms were already selected so will need to hide and force reactivate of choice on rooms.
                                   var roomsModuleSummary = $('#roomModuleSummary').is(":visible"),
                                       roomsModuleActive = $('#roomModuleDisabled').is(":visible") || roomsModuleSummary,
                                       //Populate the summary view from the selected flights data returned.
                                       selectedtransports = transportData.selectedtransportModuleModel.selectedTransports,
                                       taurusFlightNo = selectedtransports.taurusFlightNo,
                                       transfersIncluded = selectedtransports.transfersIncluded,
                                       journeys = selectedtransports.journeys;

                                   //If transfers are included.
                                   var transfersIncludedTxt = "";
                                   transfersIncludedTxt = transfersIncluded
                                       ? 'Transfers included'
                                       : 'Transfers not included';

                                   //Build up the html by pushing it into a string builder array.
                                   var stringBuilder = [];
                                   stringBuilder.push('<div class="flights" id="' + taurusFlightNo + '">');

                                   //For each of the journeys.
                                   //Put the selected options into the transport summary.                                                     
                                   $.each(journeys, function (idNo, transportOption) {
                                       //If direction is inbound change it to return.
                                       var direction = transportOption.direction;

                                       if (direction === "Inbound") {
                                           direction = "Return";
                                       }

                                       //Then build the html for the selected transport options and push into the string builder.
                                       stringBuilder.push(
                                           '<div class="flightsBody row ' + transportOption.direction + '"' + 'id="' +
                                           transportOption.direction + '">' + '<h5 class="direction col-12">' + ' <span class="directionName">' + direction + '</span> <span class="directionDate">' + moment(transportOption.outboundDateTime).format("ddd Do MMM YYYY") + '</span></h5 > ' +
                                            '<div class="flightsBodyCarrier col-12 col-md-3">' +
                                           '<span class="toCarrierName">' + transportOption.carrierName + '</span>' +
                                           '<span class="toCarrierCode">' + transportOption.carrierCode + ' - ' + '</span>' +
                                           '<span class="toClass">' + transportOption.cabinClass + '</span>' +
                                           '</div>' +
                                           '<div class="flightsBodyDeparture col-12 col-md-4">' +
                                           '<span class="toOutboundPort">' + transportOption.outboundPort + '</span>' +
                                           '<span class="toOutboundDateTime">' + moment(transportOption.outboundDateTime).format("ddd Do MMM YYYY - HH:mm") + '</span>' +
                                           '</div>' +
                                           '<div class="flightsBodyTime col-12 col-md-1">' +
                                           '<span class="addPlane fa"></span><br /><span class="toStops">' + transportOption.stops + '</span>' +
                                           '</div>' +
                                           '<div class="flightsBodyArrival col-12 col-md-4">' +
                                           '<span class="toInboundPort">' + transportOption.inboundPort + '</span>' +
                                           '<span class="toInboundDateTime">' + moment(transportOption.inboundDateTime).format("ddd Do MMM YYYY - HH:mm") + '</span>' +
                                           '</div></div>'
                                       );
                                   });

                                   stringBuilder.push('<div class="flightsBodyButton">' + '<span class="toTransfersIncluded">' + transfersIncludedTxt + '</span>' +
                                       '<span class="changeButton">' +
                                       '<a class="btn btn-third pull-right changeFlights">' +
                                       'Change transport' + '</a></span></div></div>');

                                   //Join the html to the transport summary container.
                                   //Empty the transport container before refilling it
                                   $('#transportSummaryContainer').empty(); // required in cases where you have re-selected or selected new flights
                                   $('#transportSummaryContainer').append(stringBuilder.join(""));

                                   //TigerBay show date instead of inbound/outbound.
                                   if ($("#loadTransport").find("#Inbound").length > 0) {
                                       $('h5.direction .directionName').show();
                                       $('h5.direction .directionDate').hide();
                                   } else {
                                       $('h5.direction .directionName').hide();
                                       $('h5.direction .directionDate').show();
                                   }

                                   //If transport option contains the word airport then add the plane icon.
                                   if ($('.toOutboundPort').text().toLowerCase().indexOf("airport") >= 0) {
                                       $('.addPlane').addClass('fa-plane');
                                   } else {
                                       $('.addPlane').removeClass('fa-plane');
                                   }

                                   //If transport option contains the word airport, change button txt to select flight/selected flight when selected.
                                   if ($('.toOutboundPort').text().toLowerCase().indexOf("airport") >= 0) {
                                       $('.changeFlights').text("Change flight");
                                   }
                                       //If transport option contains the word Eurostar, change button txt to select this Eurostar/selected Eurostar when selected.
                                   else if ($('.toCarrierName').text().toLowerCase().indexOf("eurostar") >= 0) {
                                       $('.changeFlights').text("Change Eurostar");
                                   } else {
                                       $('.changeFlights').text("Change");
                                   }

                                   if (roomsModuleActive === true) {
                                       if (roomsModuleSummary === true) {
                                           $('#roomModuleSummary').hide();
                                       }

                                           $('#transportModuleSummary').show();
                                               $('#transportModuleActive, #transportModuleDisabled, #roomModuleDisabled').hide();
                                                $("html, body").animate({ scrollTop: $("#transportModuleSummary").offset().top + $('#transportModuleSummary')[0].scrollHeight + 5 }, "slow", "swing");                                       

                                       //Activate rooms module.
                                       showActiveRooms();

                                       //Update the basket and activate the rooms module.
                                       beBasket.updateBasket();                                       
                                       getRoomsActive();
                                   } else {
                                       //River & Third Party Cruises - get cabins                                       
                                       getCabinActive();
                                   }
                               } else {
                                   console.log("Failed to select Transport Choice errordetails are <" + transportData.errorDetails + ">");
                                   //Redirect to error page("/checkout/timeout").
                               }
                           },
                           error: function (xhr) {
                               $(transporterror).text("Failed to connect to server...");
                               $(transporterror).show();
                               console.log("An error occured getting transport details from server : " + xhr.status + " " + xhr.statusText + " statuscode=" + xhr.statusCode);
                               //Should now redirect to timeout/error page.
                           }
                       });
                   }

                   //GetRoomsActive function: activate the rooms module.
                   function getRoomsActive() {
                       $(".roomsUnavailableContainer p").empty();
                       $(".roomsUnavailableContainer").hide();

                       loader.show("Getting room options...");

                       //ACTIVATE THE ROOMS MODULE.
                       $.ajax({
                           url: '/roomsmodule/activate',
                           dataType: 'json',
                           success: function (roomsResult) {
                               //Empty the rooms container.
                               $('.roomSelectionContainer').empty();

                               //If the rooms result was a success then build the html.
                               if (roomsResult.success && roomsResult.roomsModuleModel !== null && roomsResult.roomsModuleModel.roomOptions != null && roomsResult.roomsModuleModel.roomOptions.length > 0) {
                                   var roomsStringBuilder = [];

                                   //For each of the room options get the results.
                                   $.each(roomsResult.roomsModuleModel.roomOptions, function (roomid, roompod) {
                                       roomsStringBuilder.push('<div class="room bookingDropdown" id="' + roomid + '">');
                                       //Inside the object: roomCode, price, accommodationCode, description,fromDay 
                                       //roomFeaturesDescription, roomName 
                                       roomsStringBuilder.push('<span class="info"><p class="departuresAvailable"><strong class="roDisplayName">'
                                           + roompod.displayName + '</strong></p>');

                                       //For each of the room features inside the rooms.
                                       if (roompod.roomFeatures != null && roompod.roomFeatures.length > 0) {
                                           roomsStringBuilder.push('<a href="#" class="viewAllRoom">View all room features</a>');
                                           roomsStringBuilder.push('<ul class="roFeatures">');

                                           $.each(roompod.roomFeatures, function (roomFeaturesid, roomFeatures) {
                                               //Inside the object: name, imageUrl
                                               //var roImageUrl = $('.roImageurl').attr("src", roomFeatures.imageUrl);
                                               roomsStringBuilder.push('<li>' + '<p class="roName"><img class="roImageUrl" src="' + roomFeatures.imageUrl + '" />' + roomFeatures.name + '</p>' +
                                                   '</li>');
                                           });

                                           roomsStringBuilder.push('</ul>');
                                       };

                                       roomsStringBuilder.push('</span>');

                                       roomsStringBuilder.push('<span class="priceCol">' + '<p class="roPrice"><strong>' + roompod.priceString + '</strong>' +
                                           '<span>per person</span>' + '</p>' +
                                           '<a class="btn btn-primary action roRoomCode selectRoom" href="#rs" data-roomCode="' + roompod.roomCode + '" data-accCode="' + roompod.accommodationCode + '" data-fromDay="' + roompod.fromDay + '" data-roomPrice="' + roompod.price + '" data-occupancies="' + roompod.occupancies + '" id="' + roomid + '_' + roompod.roomCode +
                                           '">Select room</a>' + '</span>');

                                       roomsStringBuilder.push('</div>');
                                   });

                                   //Join the html to the rooms container.
                                   $('.roomSelectionContainer').append(roomsStringBuilder.join(""));

                               } else {
                                   $(".roomsUnavailableContainer p").html(roomsResult.roomsModuleModel.roomsUnavailableMessage);
                                   $(".roomsUnavailableContainer").show();
                               }

                               // adobe
                               var noOfRoomsOptions = roomsResult.roomsModuleModel.roomOptions!=null ? roomsResult.roomsModuleModel.roomOptions.length : 0;
                               AdlAddUpdateItem("numberOfRooms", noOfRoomsOptions.toString());

                               loader.hide();
                           }
                       }); //END OF ROOMS ACTIVATE.
                   }

                   //GetTransportActive function: activate the transport module.
                   function getTransportActive(isMoreSeatsEnabled) {
                       if (isMoreSeatsEnabled) {
                           var loadingMessage = "Confirming availability and prices...";
                           AdlAddUpdateItem("moreSeatsTriggered", "true", "adlProductInfoItem");
                           util.satelliteTrack("more seats");
                       }

                       loader.show(loadingMessage);

                       $.ajax({
                           url: '/transportmodule/activate',
                           dataType: "json",
                           success: function (transportResult) {
                               if (transportResult.success) {
                                   showActiveTransport();
                                   loadTransportHtml(isMoreSeatsEnabled);
                               } else {
                                   console.log("Failed to Activate transportModule errordetails are <" + transportResult.errorDetails + ">");
                                   redirectToErrorPage(transportResult.redirectUrl, transportResult.errorDetails);
                               }
                           },
                           error: function (xhr) {
                               console.log("An error occured getting transport details from server : " + xhr.status + " " + xhr.statusText + " statuscode=" + xhr.statusCode);
                               loader.hide();
                           }
                       });
                   }

                   function loadTransportHtml(isMoreSeatsEnabled) {
                       return $.get("/transportmodule/activatemodule", function (transportHtml) {
                           var transportLoadContainer = $("#loadTransport");

                           transportLoadContainer.empty().html(transportHtml).show();

                           if (isMoreSeatsEnabled) {
                               transportLoadContainer.find(".more-seats-tooltip").tooltip();

                               var moreSeatsUnavailable = transportLoadContainer.find("#moreSeatsUnavailableContainer");

                               if (moreSeatsUnavailable.length) {
                                   var moreSeatsNegativePrice = moreSeatsUnavailable.data("negative-price").toLowerCase() === "true";

                                   if (moreSeatsNegativePrice) {
                                       AdlAddUpdateItem("moreSeatsNegativePrice", "true", "adlProductInfoItem");
                                   } else {
                                       AdlAddUpdateItem("moreSeatsFailedRequest", "true", "adlProductInfoItem");
                                   }
                               }

                               var changedPriceContainer = $("#transportModuleChanged");

                               if (changedPriceContainer.length) {
                                   if (changedPriceContainer.data("price-changed").toLowerCase() === "true") {
                                       AdlAddUpdateItem("moreSeatsPriceChange", "true", "adlProductInfoItem");
                                   }

                                   if (changedPriceContainer.data("cabin-changed").toLowerCase() === "true") {
                                       AdlAddUpdateItem("moreSeatsCabinChange", "true", "adlProductInfoItem");
                                   }
                               }

                               util.satelliteTrack("more seats");
                           }

                           // adobe
                           var noOfTransportOptions = $('#transportContainer .flights').length;
                           AdlAddUpdateItem("noOfTransportOptions", noOfTransportOptions.toString());
                           AdlAddUpdateItem("soldOut", "no");

                           //Loop Through multicom flights and checkFlightAvailability.
                           $('.multicom').each(function (index, flightdetails) {
                               var multicomDetails = $(flightdetails),
                                   flightNo = flightdetails.id,
                                   tCarrierCode = multicomDetails.find(".toOutboundPort").data("fcarriercode"),
                                   tDeparturePort = multicomDetails.find(".toOutboundPort").data("foutportcode"),
                                   tRegionalFlight = multicomDetails.data("regionalflight"),
                                   multicomRoomCode = multicomDetails.data("multicomroomcode"),
                                   //Use to show hide the multicom flight details by this id.
                                   multicomflightId = '#' + flightNo + '.flights.multicom ',
                                   multicomcheck = multicomflightId + '.multicomcheck',
                                   multicomerror = multicomflightId + '.multicomerror';

                               var taurusFlightNo = {
                                   taurusFlightNo: flightNo,
                                   carrierCode: tCarrierCode,
                                   departurePort: tDeparturePort,
                                   regionalFlight: tRegionalFlight,
                                   roomCode: multicomRoomCode
                               }

                               if (typeof taurusFlightNo !== "undefined") {

                                   // explicitly show the specifc flight id 
                                   $(multicomcheck).show();

                                   $.ajax({
                                       url: '/transportmodule/GetMultiComFlight',
                                       type: 'POST',
                                       data: JSON.stringify(taurusFlightNo),
                                       contentType: 'application/json',
                                       dataType: 'json',
                                       success: function (result) {
                                           if (result.success === true) {
                                               if (result.transportMulticomModel.availabilityStatus === "Available") {
                                                   var multicomPrice = result.transportMulticomModel.pricePerPerson;

                                                   $(multicomflightId + ' .priceButton .selectFlights').attr('data-price', multicomPrice);

                                                   //Update price and Hide Spinner!
                                                   $(multicomflightId + ' .priceButton .priceFrom .toPrice').text("£" + multicomPrice);
                                                   $(multicomcheck).hide();
                                                   $(multicomflightId).find(".priceButton").show();
                                               } else {
                                                   $(multicomcheck).hide();
                                                   $(multicomerror).text("Sold Out!");
                                                   $(multicomerror).show();
                                                   AdlAddUpdateItem("soldOut", "yes");
                                                   util.satelliteTrack("flight sold out");
                                               }
                                           } else {
                                               $(multicomcheck).hide();
                                               $(multicomerror).text("Failed to retrieve prices from server...(retry?)");
                                               $(multicomerror).show();

                                               console.log("Failed to get a sucessful response from GetMultiComFlight errorDetails=<" + result.errorDetails + ">");
                                           }
                                       },
                                       error: function (xhr) {
                                           $(multicomcheck).hide();
                                           $(multicomerror).text("Failed to connect to server server...");
                                           $(multicomerror).show();

                                           console.log("An error occured getting multicom details from server : " + xhr.status + " " + xhr.statusText + " statuscode=" + xhr.statusCode);
                                       }
                                   });
                               }
                           });
                       }).done(function() {
                           loader.hide();
                       });
                   }

                   //Select room button (this is for page reload).
                   $(document).on('click', '.selectRoom', function (room) {
                       selectRooms(room);
                   });

                   //SelectRooms function: Select the room, send that information back to the database and activate the next module.
                   function selectRooms(selectedRoom) {
                       $('.selectRoom').each(function () {

                           var currentRoom = $(this).attr('id');
                           if (selectedRoom.target.id === currentRoom) {
                               //Adobe.
                               AdlAddUpdateItem("BookingJourneyStep", "rooms");

                               //Highlight only the room that is selected.
                               $('.room').removeClass('roomSelected');
                               $(this).closest('.room').addClass('roomSelected');
                               $('.selectRoom').removeClass('btn-success').text("Select room");
                               $(this).addClass('btn-success').text("Selected room");

                               var roomCode = $(this).data('roomcode'),
                                   accomCode = $(this).data('acccode'),
                                   fromDay = $(this).data('fromday'),
                                   roomPriceValue = $(this).data('roomprice'),
                                   occupancies = $(this).data('occupancies'),
                                   roomDisplayName = $(this).closest('.roomSelected').find('.departuresAvailable').find('.roDisplayName').text(),
                                   selectedRoomDisplayName = $(this).parent().find('.roDisplayName').text(),
                                   getRoomFeatures = $(this).closest('.roomSelected').find('.roFeatures').html();

                               $('.selroFeatures').html(getRoomFeatures);
                               $('.selroDisplayName').html(roomDisplayName);

                               if (getRoomFeatures != null) {
                                   $('.viewAllRoom').html("View all room features");
                               }

                               //Room Options model.
                               var roomOptionsModel = {
                                   "Occupancies": occupancies,
                                   "DisplayName": selectedRoomDisplayName,
                                   "RoomCode": roomCode,
                                   "Price": roomPriceValue,
                                   "AccommodationCode": accomCode,
                                   "RoomFeaturesDescription": "",
                                   "Description": roomDisplayName,
                                   "RoomFeatures":
                                   [
                                       {
                                           Name: "",
                                           ImageUrl: "",
                                       }
                                   ],
                                   "RoomName": selectedRoomDisplayName,
                                   "FromDay": fromDay
                               }

                               // adobe
                               localStorage.setItem("totalPrice", roomPriceValue);
                               AdlAddUpdateItem("totalPrice", roomPriceValue);

                               loader.show("Saving your room choice...");

                               //POST SELECTED ROOMS > GET FLAG.
                               $.ajax({
                                   url: '/roomsmodule/select',
                                   type: 'POST',
                                   data: JSON.stringify(roomOptionsModel),
                                   dataType: 'json',
                                   contentType: 'application/json; charset=utf-8',
                                   success: function (roomData) {
                                       if (roomData.success) {
                                           $('#roomModuleSummary').attr('data-summary', 'summary');
                                           booknow.UpdateSummary("noSummary");

                                           $('#roomModuleSummary').show();
                                           $('#roomModuleActive, #roomModuleDisabled').hide();                                           
                                           $("html, body").animate({ scrollTop: $("#booknowModule").offset().top - 15 }, "slow", "swing");                                       

                                           booknow.ActivateBookNow();
                                           beBasket.updateBasket();
                                       } else {
                                           console.log("There was an error:Failed to save room details <" + roomData.errorDetails + ">");
                                       }
                                   },
                                   error: function (roomData) {
                                       console.log("There was an error:" + roomData.errorDetails);
                                   }
                               });
                           }
                       });
                   }

                   // River/Third part cabin data
                   function getCabinActive() {
                       loader.show("Searching for cabins...");

                       $.get(settings.cruiseurl, function (response) {
                           if (response) {
                               // poke new cabin data into grades module
                               $('#othercruisePickYourCabin').replaceWith(response);

                               // hide sort icons on any columns with duplicate values throughout column
                               discoverSortable();

                               var transportVisible = $('#transportModuleDisabled').is(":visible");

                               if (transportVisible) {
                                   $("html, body").animate({ scrollTop: $("#transportModuleActive").offset().top }, 'fast', 'swing', function () {
                                       $('#transportModuleSummary').slideDown("fast", function () {

                                           // if this is a cruise, activate the Pick Your Cabin module
                                           $('#othercruisePickYourCabin').show("fast", function () {
                                               $('#transportModuleActive').hide("fast", function () {
                                                   $('.pickyourcabinActive').show();
                                                   $('#transportModuleDisabled, .pickyourcabinDisabled, .pickyourcabinSummary').hide();
                                               });
                                           });
                                       });
                                   });
                               } else {
                                   // if this is a cruise, activate the Pick Your Cabin module
                                   $('.pickyourcabinActive').show();
                                   $('.pickyourcabinDisabled, .pickyourcabinSummary').hide();

                                   $("html, body").animate({ scrollTop: $("#othercruisePickYourCabin").offset().top - 15 });
                               }

                               // no Of Grades & Cabins
                               var noOfCabins = 0;
                               var noOfGrades = 0;

                               if ($(".numberCabins").length > 0) {
                                   $(".numberCabins:visible").each(function () {
                                       noOfGrades += 1;
                                       var cabins = $(this).text();
                                       noOfCabins = noOfCabins + parseInt(cabins);
                                   });
                               } else if ($(".cabingrade:visible")) {
                                   $(".cabingrade:visible").each(function () {
                                       noOfGrades += 1;
                                   });
                               }

                               AdlAddUpdateItem("numberOfGrades", noOfGrades.toString());
                               AdlAddUpdateItem("numberOfCabins", noOfCabins.toString());
                           }

                           loader.hide();
                       });
                   }

                   //Show and hides: Show the corresponding div and hide the other states.
                   function showActiveDepartures() {
                       $("#depModuleActive").show();
                       $("#depModuleSummary, #depModuleDisabled").hide();
                       $("html, body").animate({ scrollTop: $("#depModuleActive").offset().top - 15}, 'slow', 'swing');
                   }

                   function showSummaryDepartures() {
                       $('#depModuleActive, #depModuleDisabled').hide();
                       $('#depModuleSummary').show();
                   }

                   function showDisabledDepartures() {
                       $('#depModuleDisabled').slideDown("slow", function () {
                           $('#depModuleSummary').slideUp('slow');
                           $('#depModuleActive').slideUp('slow');
                       });
                   }

                   function showActiveTransport() {
                       $('#transportModuleActive').show();
                       $('#transportModuleSummary, #transportModuleDisabled').hide();
                       $("html, body").animate({ scrollTop: $("#depModuleSummary").offset().top + $('#depModuleSummary')[0].scrollHeight + 5 }, "slow", "swing");                                       

                       //ADL call
                       AdlAddUpdateItem("pageName", "travel|purchase|checkout|transport");

                       function adlTransport() {
                           util.satelliteTrack("virtualPageViewTBJ");

                           //after the tracking call set previous page name to this value
                           //set a timeout to prevent it getting set before it's been read
                           //also add it to local storage so that a page change picks up the correct value
                           setTimeout(function () {
                               var prevpage = localStorage.getItem("previousPageName");

                               if (!isNullUndefEmpty(prevpage)) {
                                   AdlAddUpdateItem("previousPageName", prevpage);
                               }

                               localStorage.setItem("previousPageName", "travel|purchase|checkout|transport");
                           }, 999);
                       };

                       clearTimeout(VPVtimer);
                       VPVtimer = setTimeout(adlTransport, 250);
                   }

                   function showSummaryTransport() {
                       $('#transportModuleSummary').show();
                       $('#transportModuleDisabled, #transportModuleActive').hide();
                   }

                   function showDisabledTransport() {
                       $('#transportModuleSummary, #transportModuleActive').hide();
                       $('#transportModuleDisabled').show();
                   }

                   function showActiveRooms() {
                       $('#roomModuleActive').show();
                       $('#roomModuleSummary, #roomModuleDisabled').hide();
                       $("html, body").animate({ scrollTop: $("#roomModuleActive").offset().top - 15 }, "slow", "swing");

                       //ADL call
                       AdlAddUpdateItem("pageName", "travel|purchase|checkout|room");

                       function adlRoom() {
                           util.satelliteTrack("virtualPageViewTBJ");

                           //after the tracking call set previous page name to this value
                           //set a timeout to prevent it getting set before it's been read
                           //also add it to local storage so that a page change picks up the correct value
                           setTimeout(function () {
                               var prevpage = localStorage.getItem("previousPageName");

                               if (!isNullUndefEmpty(prevpage)) {
                                   AdlAddUpdateItem("previousPageName", prevpage);
                               }

                               localStorage.setItem("previousPageName", "travel|purchase|checkout|room");
                           }, 999);
                       };

                       clearTimeout(VPVtimer);
                       VPVtimer = setTimeout(adlRoom, 250);
                   }

                   function showSummaryRooms() {
                       $('#roomModuleSummary').slideDown("slow", function () {
                           $('#roomModuleActive').slideUp('slow');
                           $('#roomModuleDisabled').slideUp('slow');
                       });
                   }

                   function showDisabledRooms() {
                       $('#roomModuleDisabled').slideDown("slow", function () {
                           $('#roomModuleSummary').slideUp('slow');
                           $('#roomModuleActive').slideUp('slow');
                       });
                   }

                   function showDisabledCabins() {
                       $('.pickyourcabinDisabled').slideDown("slow", function () {
                           $('.pickyourcabinSummary').slideUp('slow');
                           $('.pickyourcabinActive').slideUp('slow');
                       });
                   }

                   function showActiveBookNow() {
                       $('.booknowHolder').slideDown("slow", function () {
                           $('#booknowdisabled').slideUp('slow');
                       });
                   };

                   function showDisabledBookNow() {
                       $('#booknowdisabled').slideDown("slow", function () {
                           $('.booknowHolder').slideUp('slow');
                       });
                   }

                   function CloseAllOthers(exceptThis) {
                       //If the button clicked on is change departure, close the other modules.
                       //If they are in summary then show them in summary, else show them in disabled.
                       if (exceptThis === 'changeDeparture') {
                           closeTransport();
                           closeRooms();
                           closeBookNow();
                       }

                       //If the button clicked on is change flights, close the other modules.
                       //If they are in summary then show them in summary, else show them in disabled.
                       else if (exceptThis === 'changeFlights') {
                           closeDepartures();
                           closeRooms();
                           closeBookNow();
                       }

                       //If the button clicked on is change rooms, close the other modules.
                       //If they are in summary then show them in summary, else show them in disabled.
                       else if (exceptThis === 'changeRooms') {
                           closeDepartures();
                           closeTransport();
                           closeBookNow();
                       }
                   }

                   function closeDepartures() {
                       //If the attribute is set to summary then show the module in summary, otherwise show it in disabled.
                       $('#depModuleSummary').attr('data-summary') === "summary"
                           ? showSummaryDepartures()
                           : showDisabledDepartures();
                   }

                   function closeTransport() {
                       //If the attribute is set to summary then show the module in summary, otherwise show it in disabled.
                       $('#transportModuleSummary').attr('data-summary') === "summary"
                           ? showSummaryTransport()
                           : showDisabledTransport();
                   }

                   function closeRooms() {
                       //If the attribute is set to summary then show the module in summary, otherwise show it in disabled.
                       $('#roomModuleSummary').attr('data-summary') === "summary"
                           ? showSummaryRooms()
                           : showDisabledRooms();
                   }

                   function closeCabins() {
                       showDisabledCabins();
                   }

                   function closeBookNow() {
                       //If the attribute is set to summary then show the module in summary, otherwise show it in disabled.
                       $('#booknowactive').attr('data-summary') === "summary"
                           ? showActiveBookNow()
                           : showDisabledBookNow();
                   }

                   //#TODO Probably needs a better "global" redirect strategy for this ... 
                   function redirectToErrorPage(errorpage, errordetails) {
                       console.log("redirecting to error/timeoutpage... due to the following error details=<" + errordetails + ">");
                       window.location.replace(errorpage);
                       return null;
                   }

                   // no departures found, click button to reload page
                   $(document).on('click', '.GetDeparturesBtn', function () {
                       // reload the page 
                       location.reload();
                   });

                   // no departures found, click button to reload page with new availability
                   $(document).on('click', '.ReloadPageBtn', function () {
                       var newUrl,
                           startpos,
                           endpos,
                           stringToChange;

                       if (window.location.search.indexOf("guestschanged") > 0) {
                           // edit this parameter out, grabbing the prev no of guests value first
                           startpos = window.location.search.indexOf("guestschanged") - 1;
                           endpos = startpos + 16;

                           var prevguests = window.location.search.substring(startpos + 15, endpos);

                           if (isNaN(parseInt(prevguests))) {
                               prevguests = "2";
                           }

                           stringToChange = window.location.search.substring(startpos, endpos);
                           newUrl = window.location.search.replace(stringToChange, "");

                           // having taken the previous setting from the url, set the availability back to this value
                           // or 2, if no availability found
                           if (newUrl.indexOf("availability") > 0) {
                               startpos = window.location.search.indexOf("availability");
                               endpos = startpos + 14;
                               stringToChange = newUrl.substring(startpos, endpos);
                               newUrl = newUrl.replace(stringToChange, "availability=" + prevguests);
                           } else {
                               newUrl = newUrl + "&availability=" + prevguests;
                           }
                       } else {
                           // if no prev no of guests, just default to availability = 2 
                           if (window.location.search.indexOf("availability") > 0) {
                               startpos = window.location.search.indexOf("availability");
                               endpos = startpos + 14;
                               stringToChange = window.location.search.substring(startpos, endpos);
                               newUrl = window.location.search.replace(stringToChange, "availability=2");
                           } else {
                               newUrl = window.location.search + "&availability=2";
                           }
                       }

                       window.location = window.location.protocol + "//" + window.location.hostname + window.location.pathname + newUrl;
                   });

                   $('#Transport.departurePod').addClass("d-block d-md-flex");
               }
           };
       });
